import { Auth } from 'aws-amplify';

/**
 * Retrieve the appropriate microservice url
 * @param {String} microserviceType
 * @return {String}
 */
const getBaseUrl = (microserviceType = 'api') => {
  let url;
  const isDev = process.env.REACT_APP_STAGE === 'dev';
  switch (microserviceType) {
    case 'api':
      url = isDev ? 'https://api-dev.kangarootime.com/api' : 'https://api.kangarootime.com/api';
      break;
    case 'timecards':
      url = isDev ? 'https://timecards-dev.kangarootime.com/api' : 'https://timecards.kangarootime.com/api';
      break;
    case 'identity':
      url = isDev ? 'https://identity-dev.kangarootime.com/api' : 'https://identity.kangarootime.com/api';
      break;
    case 'menus':
      url = isDev ? 'https://menu-dev.kangarootime.com/api' : 'https://menu.kangarootime.com/api';
      break;
    case 'gallery':
      url = isDev ? 'https://gallery-dev.kangarootime.com/api' : 'https://gallery.kangarootime.com/api';
      break;
    case 'events':
      url = isDev ? 'https://events-dev.kangarootime.com/api' : 'https://events.kangarootime.com/api';
      break;
    case 'messaging':
      url = isDev ? 'https://messaging-dev.kangarootime.com/api' : 'https://messaging.kangarootime.com/api';
      break;
    default:
      url = 'https://api-dev.kangarootime.com/api';
      break;
  }

  return url;
};

const get = (endpoint, microserviceRequestType = 'api') => {
  const session = Auth.currentSession();
  const baseURL = getBaseUrl(microserviceRequestType);
  const url = `${baseURL}/${endpoint}`;

  return new Promise((resolve, reject) => {
    session.then((results) => {
      if (process.env.REACT_APP_STAGE === 'dev') {
        console.log(results.idToken.jwtToken);
      }
      fetch(url, {
        method: 'GET',
        headers: {
          Authorization: results.idToken.jwtToken,
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
          // come up with a better error message
            throw new Error('API error');
          }
        })
        .then(json => resolve(json))
        .catch(error => reject(error));
    })
      .catch(error => reject(error));
  });
};

const post = (endpoint, body = {}, microserviceRequestType = 'api') => {
  const session = Auth.currentSession();
  const baseURL = getBaseUrl(microserviceRequestType);
  const url = `${baseURL}/${endpoint}`;

  return new Promise((resolve, reject) => {
    session.then((results) => {
      fetch(url, {
        method: 'POST',
        headers: {
          Authorization: results.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    })
      .catch(error => reject(error));
  });
};

export default {
  get,
  post
};
